import React from 'react';
import PaymentLinkTable from '../../components/payment-link-system/PaymentLinkTable';
import ReactVortoxSpinner from '../../components/common-components/ReactVortoxSpinner';
import { EditIcon1, BinIcon } from '../../images/icons/icons';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { showConfirmAlert } from '../../components/components-react/ReactAlert';
import { commonDeleteApi } from '../../redux/reducers/deleteApiSlice';

const OfferListingTable = ({
    tableData,
    isPage,
    setIsPage,
    pagination,
    loading,
    pageLimit,
    setPageLimit,
    setModValues,
    userInfoData,
    callFunction
}) => {
    const dispatch = useDispatch();

    // Utility function to transform title
    const formatTitle = (title) => {
        if (!title) return "-";
        return title
            .split('_') 
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
            .join(' '); 
    };

    const tbColumns = [
        {
            dataField: "title",
            text: "Offer Title",
            formatter: (value, row) => {
                return <div className="text-left minWidth150">{formatTitle(value)}</div>;
            },
        },
        {
            dataField: "campaign_name",
            text: "Category Name",
            formatter: (value, row) => {
                return <div className="text-left minWidth150">{formatTitle(value)}</div>;
            },
        },
        {
            dataField: "actual_price",
            text: "Actual Price",
            formatter: (value, row) => {
                return <div className="text-right minWidth120">₹{value || 0}</div>;
            },
        },
        {
            dataField: "offer_price",
            text: "Offer Price",
            formatter: (value, row) => {
                return <div className="text-right minWidth120">₹{value || 0}</div>;
            },
        },
        {
            dataField: "valid_from",
            text: "Start Date",
            formatter: (value, row) => {
                return <div className="text-center minWidth120">{value ? new Date(value).toLocaleDateString() : "-"}</div>;
            },
        },
        {
            dataField: "valid_to",
            text: "End Date",
            formatter: (value, row) => {
                return <div className="text-center minWidth120">{value ? new Date(value).toLocaleDateString() : "-"}</div>;
            },
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (value, row) => {
                const isActive = value === "active";
                const bgColor = isActive ? "#28a745" : "#dc3545";
                const textColor = "#fff";
                const pillStyle = {
                    backgroundColor: bgColor,
                    color: textColor,
                    borderRadius: "999px",
                    padding: "4px 16px",
                    display: "inline-block",
                    fontWeight: 500,
                    fontSize: "0.95em",
                    minWidth: 60,
                    textTransform: "capitalize",
                };
                return (
                    <div className="text-center minWidth120">
                        <span style={pillStyle}>{value || "-"}</span>
                    </div>
                );
            },
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: (value, row) => {
                return (
                    <div className="d-flex gap-4 justify-content-center minWidth120 align-items-center">
                        <span onClick={() => setModValues({
                            isModOpen: true,
                            modName: "edit",
                            rowData: row
                        })}><EditIcon1  /></span>
                        <span onClick={() => handleDelete(row)}><BinIcon /></span>
                    </div>
                );
            },
        },
    ];

    const handleDelete = (row) => {
        if (!row?.uid) {
            toast.error('UID required!');
            return;
        }

        const confirm = async () => {
            try {
                const response = await dispatch(
                    commonDeleteApi({
                        TOKEN: userInfoData?.token,
                        endpoint: `/ongoing_offer/${row.uid}`,
                        queryParams: { uid: row.uid },
                    })
                ).unwrap();

                if (response?.status) {
                    toast.success(response?.message || 'Deleted successfully!');
                    if (typeof callFunction === 'function') callFunction();
                } else {
                    toast.error(response?.message || 'Cannot delete!');
                }
            } catch (error) {
                toast.error(error || 'Failed to delete');
            }
        };

        showConfirmAlert(confirm, 'Are you sure you want to delete?');
    };

    return (
        <div className="fullWidthFlexCenter mt30 overflowAuto separatedTable no-border-table">
            {loading ? (
                <ReactVortoxSpinner />
            ) : (
                <PaymentLinkTable
                    tableData={tableData || []}
                    tableColumns={tbColumns}
                    tablePagination={pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    isFirstColSticky={false}
                />
            )}
        </div>
    );
};

export default OfferListingTable;